// Ported from the Polaris kit: src/product/art/tones.js (the tones only; the scenes are not ported).
// The six tones of the art; their colors are in assets/scss/_polaris-art.scss.
export const TONES = ['sky', 'ember', 'meadow', 'dawn', 'tide', 'sand'];
